import React, {useState, useEffect, useRef, useMemo} from 'react'
import {Tag} from '@bedrock/components'
import classNames from 'classnames/bind'
import styles from './index.less'
import {PriorityEnum} from "#services/api";

const cx = classNames.bind(styles)

export const PRIORITY_CONFIGS = {
  'URGENCY_LEVEL': {
    text: '紧急',
    color: 'light-red',
  },
  'HIGH_LEVEL': {
    text: '高',
    color: 'light-orange',
  },
  'MEDIUM_LEVEL': {
    text: '中',
    color: 'light-blue',
  },
  'MIDDLE_LEVEL': {
    text: '中',
    color: 'light-blue',
  },
  'LOW_LEVEL': {
    text: '低',
    color: 'light-grey',
  },
  default: {
    text: '未知',
    color: 'light-grey',
  }
}

export default function PriorityTag(props: {
  value?: PriorityEnum,
} & React.ComponentProps<typeof Tag>) {
  const {value, ...rest} = props
  const showConfig = PRIORITY_CONFIGS[value?.toUpperCase()] || PRIORITY_CONFIGS.default
  return <Tag
      size='xSmall'
      color={showConfig.color}
      {...rest}
      text={showConfig.text}
  />
}
